import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import useCommonMediaQuery from '../../hooks/useCommonMediaQuery';

const DEFAULT_MESSAGE =
  'Are you sure you want to close this page? Unsaved changes will be lost.';

const UnSavedChangesModal = ({
  open,
  onStay,
  onConfirmDiscard,
  message = DEFAULT_MESSAGE,
}) => {
  const isMobileFullscreen = useCommonMediaQuery('sm');

  return (
    <Dialog
      open={open}
      onClose={(e, reason) => {
        if (reason !== 'backdropClick') onStay();
      }}
      maxWidth="xs"
      fullWidth
      fullScreen={isMobileFullscreen}
      disableScrollLock
      sx={{ zIndex: 10004 }}
      PaperProps={{
        sx: {
          zIndex: 10004,
          display: 'flex',
          flexDirection: 'column',
          ...(isMobileFullscreen
            ? {
                m: 0,
                width: '100%',
                maxWidth: '100%',
                height: '100%',
                maxHeight: '100%',
                minHeight: '100%',
                borderRadius: 0,
                p: 1,
              }
            : { borderRadius: 1, p: 1 }),
        },
      }}
    >
      <DialogContent
        sx={{
          p: 2,
          textAlign: 'center',
          flex: isMobileFullscreen ? 1 : undefined,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 1,
            }}
          >
            <WarningIcon sx={{ fontSize: 40, color: '#f59e0b' }} />
          </Box>
          <Typography
            variant="body1"
            sx={{
              color: '#000000',
              mb: 1,
              fontSize: '0.95rem',
              lineHeight: 1.4,
            }}
          >
            {message}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 1, pt: 0, justifyContent: 'center', gap: 1 }}>
        <Button
          onClick={onStay}
          variant="outlined"
          sx={{
            borderColor: '#d1d5db',
            color: '#000000',
            backgroundColor: '#ffffff',
            px: 2.5,
            py: 1.25,
            borderRadius: 1,
            textTransform: 'none',
            fontSize: '0.875rem',
            fontWeight: 500,
            minWidth: '80px',
            '&:hover': {
              borderColor: '#9ca3af',
              backgroundColor: '#f9fafb',
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirmDiscard}
          variant="contained"
          sx={{
            backgroundColor: '#0D213B',
            color: 'white',
            px: 2.5,
            py: 1.25,
            borderRadius: 1,
            textTransform: 'none',
            fontSize: '0.875rem',
            fontWeight: 500,
            minWidth: '80px',
            '&:hover': {
              backgroundColor: '#0a1a2e',
            },
          }}
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnSavedChangesModal;
